//@ts-check
import React, { useCallback } from "react";
import { endPoint } from "src/AppConstants"
import { useAppDispatch } from "src/utils/ReduxHooks";
import useTypedSelector from "utils/useTypedSelector";
import { useI18n } from "components/lni18n";
import { imagePickerDuck } from "./ImagePickerDuck";
import classes from "./ImagePicker.module.scss";
import ImagePermissions from "./ImagePermissions";
import ImageInfo from "./ImageInfo";
import Preview from "./Preview";

/**
 * 
 * @param {{onSubmit: Function}} props
 */
const SelectedImage = ({ onSubmit }) => {

    const {  selectedImage, currentImage, subTab, imageAlign } = useTypedSelector(state => state.imagepicker);
    const { user: currentUser } = useTypedSelector(state => state.login);
    const dispatch = useAppDispatch();
    const { languageService: t } = useI18n();

    const onSubmitUrl = useCallback(()=>{
        onSubmit({ imageAlign: imageAlign, selectedImage: selectedImage.ImageId});
    }, [ imageAlign, selectedImage, onSubmit ]);


    if (!selectedImage) {
        return null;
    }


    const setSubTab = (tab) => {
        dispatch(imagePickerDuck.setSubTab(tab));
    }

    return <div className={classes.scrollPanel}>
        
        <ul className="nav nav-tabs col-12 col-lg-8 mx-auto">
            <li className="nav-item">
            
                <button  className={"nav-link" + (subTab === 'preview' ? " active" : "")} onClick={() => setSubTab('preview')} >{t.getText("preview")}</button>

            </li>
            {currentUser.Id === selectedImage.User.Id && currentImage && <li className="nav-item">
                <button className={"nav-link" + (subTab === 'information' ? " active" : "")} onClick={() => setSubTab('information')} >{t.getText("information")}</button>
            </li>
            }

            {currentUser.Id === selectedImage.User.Id && <li className="nav-item">
                <button className={"nav-link" + (subTab === 'permissions' ? " active" : "")} onClick={() => setSubTab('permissions')} >{t.getText("permissions")}</button>
            </li>
            }


        </ul>

        <div className="col-12 col-lg-8 mx-auto mt-4">


            {subTab === 'preview' && <Preview src={endPoint.GET_IMAGE_URL(selectedImage.ImageId)} onSubmit={onSubmitUrl} /> }

            {subTab === 'information' && <ImageInfo />}

            {subTab === 'permissions' && <ImagePermissions />}
        </div>
    </div>
}

export default SelectedImage;
